export const paxTranslations = {
  es: {
    adult: 'adulto',
    adults: 'adultos',
    child: 'niño',
    children: 'niños',
  },
  en: {
    adult: 'adult',
    adults: 'adults',
    child: 'child',
    children: 'children',
  },
  de: {
    adult: 'Erwachsener',
    adults: 'Erwachsene',
    child: 'Kind',
    children: 'Kinder',
  },
  fr: {
    adult: 'adulte',
    adults: 'adultes',
    child: 'enfant',
    children: 'enfants',
  },
  it: {
    adult: 'adulto',
    adults: 'adulti',
    child: 'bambino',
    children: 'bambini',
  },
  pt: {
    adult: 'adulto',
    adults: 'adultos',
    child: 'criança',
    children: 'crianças',
  },
}
export const monthAbbreviations = {
  es: ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
  en: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  de: ['JAN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'],
  fr: ['JANV.', 'FÉVR.', 'MARS', 'AVRIL', 'MAI', 'JUIN', 'JUIL.', 'AOÛT', 'SEPT.', 'OCT.', 'NOV.', 'DÉC.'],
  it: ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'],
  pt: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
}
